import ProxyBase from '../ProxyBase';
import ServiceProxyConfig from '../../../configs/ServiceProxyConfig';

class FinancialAnalysisProxy extends ProxyBase {
  getZMFScore(params) {
    return this.get('GetZMFScore', params);
  }

  getFinancialRatio(params) {
    return this.get('GetFinancialRatioV2', params);
  }

  getFACheckup(params) {
    return this.get('GetCheckup', params);
  }

  downloadFinancialRatio(params) {
    return this.get('DownloadFinancialRatio2', params, null, 'download');
  }
}

const financialAnalysisProxy = new FinancialAnalysisProxy(
  ServiceProxyConfig.Fundamental.FinancialAnalysis.ServiceUrl,
);
export default financialAnalysisProxy;
